// Sidebar layout state — pure module, no React, no DOM, no imports.
//
// Two modes only. Sidebar never mounts below MOBILE_BREAKPOINT
// (MainLayout renders MobileTabNavigation instead), so no narrow-viewport
// mode exists here by design.

export const EXPANDED = 'expanded';
export const RAIL = 'rail';

// Versioned persistence key (guardedStorage convention, Phase 2).
export const SIDEBAR_MODE_KEY = 'crm.ui.sidebar.v1';

const WIDTHS = { [EXPANDED]: 260, [RAIL]: 72 };

// Single source of truth for sidebar width. Unknown input gets the
// expanded default rather than propagating NaN into layout styles.
export const widthFor = (mode) => WIDTHS[mode] ?? WIDTHS[EXPANDED];

export const nextMode = (mode) => (mode === RAIL ? EXPANDED : RAIL);

// Decision 2 (PILOT-QUOTES-SHELL.md §2.1): the default when nothing is stored. The quotes
// split needs <main> >= 941 px; beside the expanded sidebar (260 px + its 1 px border,
// content-box) that takes a viewport of 1202. Below it — the tablet in portrait, ~1050 —
// the default is rail, so the split fits (1050 - 73 = 977). A stored choice always wins;
// this is only the fallback, and it is never written.
export const RAIL_DEFAULT_BELOW = 260 + 1 + 941; // 1202

export const defaultModeFor = (viewportWidth) =>
  Number.isFinite(viewportWidth) && viewportWidth < RAIL_DEFAULT_BELOW ? RAIL : EXPANDED;

// Validator for readGuarded(SIDEBAR_MODE_KEY, isValidMode, EXPANDED).
export const isValidMode = (v) => v === EXPANDED || v === RAIL;

// Sum of a section's children badge counts, for the rail section icon.
// Tolerates absent input and non-numeric entries (badge fetches are
// best-effort and may not have resolved). Returns the raw number —
// clamping to "99+" is a render concern.
export const badgeTotal = (counts) =>
  (counts || []).reduce(
    (sum, n) => sum + (typeof n === 'number' && Number.isFinite(n) ? n : 0),
    0
  );
